import { jsx as _jsx } from "react/jsx-runtime";
// Importing custom components
import { Tooltip } from '../../core/tooltip';
// Importing icons
import MuiDownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import MuiDownloadOffIcon from '@mui/icons-material/FileDownloadOffOutlined';
// Importing 3rd party dependencies
import { Fragment } from 'react';
// Importing 3rd party components
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
export const DownloadIcon = (props) => {
    // Destructuring props
    const { downloadable, href, rel, title } = props;
    return (_jsx(Fragment, { children: downloadable ? (_jsx(Link, { href: href, rel: rel, children: _jsx(DownloadIconElement, { downloadable: true, title: title }) })) : (_jsx(DownloadIconElement, { downloadable: false, title: title })) }));
};
const DownloadIconElement = (props) => {
    // Destructuring props
    const { downloadable, title } = props;
    return (_jsx(Tooltip, { placement: "top", title: title, children: _jsx(IconButton, { children: downloadable ? _jsx(MuiDownloadIcon, {}) : _jsx(MuiDownloadOffIcon, {}) }) }));
};
